import React from 'react';
import IString from './i-string';

import { getInviteCode, getInviterEmail, getInviteType, getProduct } from '../util/server-util';
import MarkedMessage, { marks } from './marked-message';

function InviteMessage() {

  const inviteCode = getInviteCode();
  let type = getInviteType();
  const email = getInviterEmail();
  const product = getProduct();

  // Posit Academy wants to always show an invitation message, but they don't have actual invites in the lucid system.
  if (product === 'academy') {
    type = 'academy_invite';
  } else if (!inviteCode || !type || !email) {
    return null;
  }

  return (
    <div className='fullPageFormContainer marginAbove'>
      <MarkedMessage mark={marks.GOOD}>
        <p><IString stringKey={`invite.${type}`} placeholders={{ email }} /></p>
        <p><IString stringKey='invite.resolution' /></p>
      </MarkedMessage>
    </div>
  );
}

export default InviteMessage;
